import type { ReactNode } from "react"
import GridBackdrop from "@/components/GridBackdrop/GridBackdrop"
import styles from "@/styles/components/Container.module.css"

interface ContainerProps {
  /** Centres the content as one block. For status screens and single-statement rounds. */
  centred?: boolean
  /** Drops the width-constrained inner wrapper, for screens that carry a full-bleed bar. */
  bare?: boolean
  children: ReactNode
}

export default function Container({ centred = false, bare = false, children }: ContainerProps) {
  const classes = [styles.container, centred ? styles.centred : ""].filter(Boolean).join(" ")

  return (
    <div className={classes}>
      <GridBackdrop />
      {bare ? children : <div className={styles.inner}>{children}</div>}
    </div>
  )
}
